import React, { useState } from 'react';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { toggleLessonCompletion } from '../../utils/lessonUtils';
import './LessonProgressButton.scss';
import SvgIcons from '../../../../services/SvgIcons';

const LessonProgressButton = ({
    trainingId,
    selectedTrainingChapter,
    selectedTrainingLesson,
    trainingDetails,
    setSelectedTrainingChapter,
    setSelectedTrainingLesson,
    setCompletedLessons,
    setTrainingProgress,
    updateVisibleChapters,
    setVisibleChapters,
    setDisplayedMobileMenu,
    contentRef,
    titleRef,
    isMobile,
    isLessonCompleted
}) => {

    const [isHoveredFromParent, setIsHoveredFromParent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        console.log('=== LessonProgressButton Click ===');
        console.log('trainingId:', trainingId);
        console.log('selectedTrainingChapter:', selectedTrainingChapter);
        console.log('selectedTrainingLesson:', selectedTrainingLesson);
        console.log('isLessonCompleted avant:', isLessonCompleted);
        
        if (isLoading) {
            console.log('Déjà en cours de traitement, ignore le click');
            return;
        }
        
        try {
            setIsLoading(true);
            console.log('Appel de toggleLessonCompletion...');
            
            const result = await toggleLessonCompletion(
                trainingId,
                selectedTrainingChapter,
                selectedTrainingLesson,
                trainingDetails,
                setSelectedTrainingChapter,
                setSelectedTrainingLesson,
                setCompletedLessons,
                setTrainingProgress,
                updateVisibleChapters,
                setVisibleChapters,
                setDisplayedMobileMenu,
                contentRef,
                titleRef,
                isMobile,
                isLessonCompleted
            );
            
            console.log('Résultat de toggleLessonCompletion:', result);
        } catch (error) {
            console.error('Erreur dans toggleLessonCompletion:', error);
            alert('Erreur lors de la mise à jour de la progression : ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <CustomBtn
            type="action"
            title={
                isLoading ? (
                    <div className='lesson-progress-button__content'>
                        <SvgIcons
                            name={'close'}
                            width={25}
                            height={25}
                            color={isHoveredFromParent ? '#EEE6DB' : '#361215'}
                            strokeWidth={'20px'}
                            className="loading-icon"
                        />
                        <span>En cours...</span>
                    </div>
                ) : isLessonCompleted ? (
                    <div className='lesson-progress-button__content'>
                        <SvgIcons
                            name={'uncheck_circle'}
                            width={25}
                            height={25}
                            color={isHoveredFromParent ? '#EEE6DB' : '#361215'}
                            strokeWidth={'20px'}
                        />
                        <span>Marquer comme<br/>Non terminée</span>
                    </div>
                ) : (
                    <div className='lesson-progress-button__content'>
                        <SvgIcons
                            name={'check_circle'}
                            width={25}
                            height={25}
                            color={isHoveredFromParent ? '#361215' : '#EEE6DB'}
                            strokeWidth={'20px'}
                        />
                        <span>Marquer comme<br/>Terminée</span>
                    </div>
                )
            }
            on_click={handleClick}
            bkg_color={isLessonCompleted ? "#EEE6DB" : "#361215"}
            bkg_color_hover={isLessonCompleted ? "#361215" : "#EEE6DB"}
            text_color={isLessonCompleted ? "#361215" : "#EEE6DB"}
            text_color_hover={isLessonCompleted ? "#EEE6DB" : "#361215"}
            border_color="#361215"
            border_color_hover="#361215"
            font_family="Playfair Display, serif"
            font_size="14px"
            border_radius="5px"
            width="auto"
            height="42px"
            setIsHoveredFromParent={setIsHoveredFromParent}
            disabled={isLoading}
        />
    );
};

export default LessonProgressButton;